import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Table,
  Modal,
  Input,
  Select,
  Popconfirm,
  Menu,
  Dropdown,
  message,
  Upload,
  Switch,
} from "antd";
import "../users/users.css";
import { useHistory } from "react-router-dom";
import { MoreOutlined, UploadOutlined } from "@ant-design/icons";
const { Option } = Select;

const Users = () => {
  const [users, setUsers] = useState([]);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState("");
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const usersPerPage = 5;

  const [showModal, setShowModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewedUser, setViewedUser] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showBulkModal, setShowBulkModal] = useState(false);

  const fetchUsers = async () => {
    try {
      const response = await fetch("/api/portal/pms/get_all_pms_teams");
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }
      const rawData = await response.json();

      const usersArray = rawData.serviceResult;

      if (Array.isArray(usersArray)) {
        setUsers(usersArray);
      } else {
        console.error("Unexpected response format:", rawData);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await fetch("/api/portal/pms/get_pms_teams_roles");
        const data = await response.json();
        setRoles(data.serviceResult);
      } catch (error) {
        console.error("Failed to fetch roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const handleSaveUser = async () => {
    const fieldErrors = {};

    if (!firstname) fieldErrors.firstname = "First Name is required.";
    if (!lastname) fieldErrors.lastname = "Last Name is required.";
    if (!email) fieldErrors.email = "Email is required.";
    if (!mobile) fieldErrors.mobile = "Mobile Number is required.";
    if (!role) fieldErrors.role = "Role is required.";

    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
      return;
    }

    const userData = {
      first_name: firstname,
      last_name: lastname,
      mobile,
      role,
      user_name: email,
    };

    if (!isEditing && password) {
      userData.password = password;
    }

    try {
      let response;
      if (isEditing) {
        const updateData = {
          ...userData,
          id: currentUserId,
        };

        response = await fetch(`/api/portal/pms/update_pms_team`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });
        message.success("User updated successfully!");
      } else {
        response = await fetch("/api/portal/pms/add_pms_team", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        });
        message.success("User added successfully!");
      }

      if (!response.ok) {
        throw new Error("Failed to save user");
      }

      fetchUsers();
      clearFormFields();
      setShowModal(false);
    } catch (error) {
      console.error("Failed to save user:", error);
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      const response = await fetch(`/api/portal/pms/delete_pms_team?id=${id}`, {
        method: "GET",
      });

      const responseData = await response.json();

      if (responseData.serviceResult !== null) {
        message.success("User deleted successfully");

        fetchUsers();
      } else {
        message.error(responseData.serviceError || "Failed to delete user");
      }
    } catch (error) {
      console.error("Failed to delete user:", error);
      message.error("An error occurred while deleting the user");
    }
  };

  const fetchUserById = async (id) => {
    try {
      const response = await fetch(
        `/api/portal/pms/get_pms_team_by_id?id=${id}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch user details");
      }
      const data = await response.json();
      setViewedUser(data.serviceResult); // Assuming data contains the details of the user
      setViewModal(true); // Open the modal after fetching user details
    } catch (error) {
      console.error("Failed to fetch user details:", error);
    }
  };

  const handleEditUser = (user) => {
    setCurrentUserId(user.seq_id);
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setEmail(user.user_name);
    setMobile(user.mobile);
    setRole(user.role);
    setIsEditing(true);
    setShowModal(true); // Open the modal for editing
  };
  const clearFormFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setMobile("");
    setRole("");
    setIsEditing(false); // Reset to add mode
  };

  const showViewModal = (user) => {
    setViewedUser(user);
    setViewModal(true);
  };

  const closeViewModal = () => {
    setViewedUser(null);
    setViewModal(false);
  };

  // const handleStatusToggle = async (id, isActive) => {
  //   const newStatus = isActive ? "Active" : "Inactive";

  //   try {
  //     // Call the API with POST request
  //     const response = await fetch("/api/portal/pms/update_pms_team", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ id, status: newStatus }),
  //     });

  //     if (response.ok) {
  //       message.success(`Status updated to ${newStatus}`);

  //       // Update the local usersData to reflect the new status
  //       setUsers((prevUsers) =>
  //         prevUsers.map((user) =>
  //           user.id === id ? { ...user, status: newStatus } : user
  //         )
  //       );
  //     } else {
  //       message.error("Failed to update status");
  //     }
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //     message.error("An error occurred while updating status");
  //   }
  // };

  const handleStatusToggle = async (id, isActive) => {
    const newStatus = isActive ? "Active" : "Inactive";

    try {
      // Call the API with a POST request
      const response = await fetch("/api/portal/pms/update_pms_team", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, status: newStatus }),
      });

      if (response.ok) {
        message.success(`Status updated to ${newStatus}`);

        // Update the local users data to reflect the new status
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.seq_id === id ? { ...user, status: newStatus } : user
          )
        );
      } else {
        message.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      message.error("An error occurred while updating status");
    }
  };

  const menu = (user) => (
    <Menu>
      <Menu.Item key="view" onClick={() => fetchUserById(user.seq_id)}>
        View
      </Menu.Item>
      <Menu.Item key="edit" onClick={() => handleEditUser(user)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete">
        <Popconfirm
          title="Are you sure delete this user?"
          onConfirm={() => handleDeleteUser(user.seq_id)}
          okText="Yes"
          cancelText="No"
        >
          Delete
        </Popconfirm>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: "Seq ID",
      dataIndex: "seq_id",
      key: "seq_id",
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
    },
    {
      title: "Username",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },

    {
      title: "Added BY",
      dataIndex: "added_by",
      key: "added_by",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Switch
          checked={record.status === "Active"}
          onChange={(checked) => handleStatusToggle(record.seq_id, checked)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Dropdown overlay={menu(record)} trigger={["click"]}>
          <Button shape="circle" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div className="page-container">
      <div className="header-container">
        <h1>Admin</h1>

        <div className="button-container">
          <Button className="userbutton" onClick={() => setShowModal(true)}>
            Add User
          </Button>
        </div>
      </div>
      <Table
        className="customtable"
        columns={columns}
        dataSource={users}
        pagination={{
          current: currentPage,
          pageSize: usersPerPage,
          total: users.length,
          onChange: (page) => setCurrentPage(page),
        }}
        rowKey="seq_id" // Make sure this is the unique key for each row
      />

      {/* Add User Modal */}
      <Modal
        title={isEditing ? "Edit User" : "Add User"}
        open={showModal}
        onCancel={() => {
          clearFormFields();
          setErrors({});
          setShowModal(false);
        }}
        footer={[
          <Button key="cancel" onClick={() => setShowModal(false)}>
            Close
          </Button>,
          <Button key="submit" onClick={handleSaveUser}>
            {isEditing ? "Update User" : "Add User"}
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="First Name">
            <Input
              value={firstname}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <div className="error">{errors.firstname}</div>
          </Form.Item>
          <Form.Item label="Last Name">
            <Input
              value={lastname}
              onChange={(e) => setLastName(e.target.value)}
            />
            <div className="error">{errors.lastname}</div>
          </Form.Item>
          <Form.Item label="Mobile">
            <Input value={mobile} onChange={(e) => setMobile(e.target.value)} />
            <div className="error">{errors.mobile}</div>
          </Form.Item>
          <Form.Item label="Email">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="error">{errors.email}</div>
          </Form.Item>
          {isEditing == false && (
            <Form.Item label="Password">
              <Input.Password
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={isEditing ? "Leave blank if not changing" : ""}
              />
              <div className="error">{errors.password}</div>
            </Form.Item>
          )}
          <Form.Item label="Role">
            <Select
              value={role}
              onChange={(value) => setRole(value)}
              placeholder="Select a role"
            >
              {roles.map((roleItem) => (
                <Option key={roleItem.role} value={roleItem.role}>
                  {roleItem.name}
                </Option>
              ))}
            </Select>
            <div className="error">{errors.role}</div>
          </Form.Item>
        </Form>
      </Modal>

      {/* View User Modal */}
      <Modal
        title="View User"
        open={viewModal}
        onCancel={closeViewModal}
        footer={[
          <Button key="close" onClick={closeViewModal}>
            Close
          </Button>,
        ]}
      >
        {viewedUser && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>First Name:</strong>
              <span>{viewedUser.first_name}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Last Name:</strong>
              <span>{viewedUser.last_name}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Username:</strong>
              <span>{viewedUser.user_name}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Mobile:</strong>
              <span>{viewedUser.mobile}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Role:</strong>
              <span>{viewedUser.role}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Added By:</strong>
              <span>{viewedUser.added_by}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: "200px" }}>Status:</strong>
              <span>{viewedUser.status}</span>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Users;
